import connect from '../axios/axios.auth';

const traspasoFunction = {
  traspasar: (data) => {
    return new Promise((resolve) => {
      connect.post(`/master/traspaso`, data)
      .then((response) => {
        resolve(response.data);
      })
    })
  },
}

export default traspasoFunction;